import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getSeedingCalculatorStrategyForJob } from './getSeedingCalculatorStrategy';
import { Identifier } from '../../../../SeedingCalculator';
import LanguageConstants from '../../../../../../constants/LanguageConstants';
import { useFeatureFlags } from '../../../../../../featureFlags/FeatureFlagContext';
import { NEW_SEEDING_MODEL_FLAG } from '../../../../../../featureFlags/featureFlags';
import type { PrescriptionJob } from '../../../../PrescriptionJob';

type SeedingCalculatorState = {
  farm: { farm: { country?: string } | null };
  settings: { userSettings: { language: string } };
  prescription: { currentJob: PrescriptionJob | null };
};

export const useSeedingCalculatorStrategy = () => {
  const farm = useSelector((state: SeedingCalculatorState) => state.farm.farm);
  const language = useSelector(
    (state: SeedingCalculatorState) => state.settings.userSettings.language
  );
  const prescriptionJob = useSelector(
    (state: SeedingCalculatorState) => state.prescription?.currentJob || null
  );
  const { isEnabled } = useFeatureFlags();
  const newSeedingModelEnabled = isEnabled(NEW_SEEDING_MODEL_FLAG);
  const seedingFeatureCountries = ['DK', 'EE', 'LT'];

  return useMemo(() => {
    if (!newSeedingModelEnabled || !prescriptionJob) return null;

    let seedingModelIdentifier: Identifier | null = null;
    if (farm?.country && seedingFeatureCountries.includes(farm.country)) {
      seedingModelIdentifier = Identifier.DANISH_SEEDING_MODEL;
    } else if (
      language === LanguageConstants.DANISH ||
      language === LanguageConstants.ESTONIAN ||
      language === LanguageConstants.LITHUANIAN
    ) {
      seedingModelIdentifier = Identifier.DANISH_SEEDING_MODEL;
    }

    if (!seedingModelIdentifier) return null;

    return getSeedingCalculatorStrategyForJob(prescriptionJob, seedingModelIdentifier);
  }, [prescriptionJob, newSeedingModelEnabled, farm?.country, language]);
};
